// extracted by mini-css-extract-plugin
module.exports = {"areasDropdown":"SelectArea_areasDropdown__2AEet"};